module.exports = __webpack_public_path__ + "img/vn.e7681414.svg";